<template>
    <asli-popup :show-close-button="true" v-model="displayModal" class="p-4">
        <div class="px-8 py-4">
            <asli-section-header class="my-[15px]">Cannot be retrieved</asli-section-header>
            <p class="text-sm mb-[15px]">
                This quote cannot be retrieved online. Please call us on {{ BRAND_PHONE_NUMBER }}. Alternatively, you
                can choose to start a new quote below.
            </p>
            <button-bar class="flex-col sm:flex-row">
                <asli-button id="new-quote" color="primary" type="button" @click="goToHomePage">
                    Start a New Quote
                </asli-button>
            </button-bar>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import { AsliPopup, AsliButton, AsliSectionHeader } from "@mbs-npm/anpost-ui";
import { computed } from "vue";
import ButtonBar from "@/components/ButtonBar.vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/router/types";
import { BRAND_PHONE_NUMBER } from "@/static/constants";

const mainStore = useMainStore();
import { getResolvedRouteName } from "@/router/utils";

const displayModal = computed({
    get: () => mainStore.displayNotQuotedModal,
    set: val => (mainStore.displayNotQuotedModal = val)
});

function goToHomePage() {
    displayModal.value = false;
    router.push({ name: getResolvedRouteName(ROUTE_NAMES.AboutYou, router.currentRoute.value) });
}
</script>
